export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00578.3a38643d.png";